import { ErrorHandler } from '@angular/core';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { environment } from 'src/environments/environment';
import Bugsnag from '@bugsnag/js';

class ConsoleLoggingErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error('Unhandled exception: ', error);
  }
}

export function ErrorHandlerFactory(): ErrorHandler {
  if (environment.bugsnagEnabled) {
    const bugsnagClient = Bugsnag.start(
      {
        apiKey: environment.bugsnagApiKey,
        releaseStage: environment.bugsnagReleaseStage
      }
    );

    return new BugsnagErrorHandler(bugsnagClient);
  } else {
    return new ConsoleLoggingErrorHandler();
  }
}
